import { tv, type VariantProps } from 'tailwind-variants'

export const selectInputVariants = tv({
  slots: {
    label: 'font-nunito font-bold pb-1',
    mainWrapper: 'flex flex-col group web:outline-none web:cursor-default',
    inputWrapper: [
      'pl-4 flex flex-row  font-nunito text-md web:outline-none text-default-text-contrast-default overflow-ellipsis',
      'border',
      'bg-default-bg-white',
      'web:outline-none',
      'web:data-[focus-visible=true]:outline-layout-focus',
      'web:data-[focus-visible=true]:outline-4',
      'web:data-[focus-visible=true]:outline-offset-1',
    ],
    placeholder: '!text-default-text-placeholder',
    dropdownIcon: 'text-default-text-placeholder',
  },
  variants: {
    color: {
      default: {
        label: 'text-default-text-contrast-default',
        placeholder: '!text-default-text-placeholder',
      },
      primary: {
        label: 'text-primary-text-contrast-default',
        placeholder: '!text-primary-text-placeholder',
      },
      secondary: {
        label: 'text-secondary-text-contrast-default',
        placeholder: '!text-secondary-text-placeholder',
      },
      success: {
        label: 'text-success-text-contrast-default',
        placeholder: '!text-success-text-placeholder',
      },
      danger: {
        label: 'text-danger-text-contrast-default',
        placeholder: '!text-danger-text-placeholder',
      },
    },
    isDisabled: {
      true: {
        inputWrapper: 'opacity-40',
        dropdownIcon: 'opacity-40',
      },
    },
    isFocused: {
      true: {
        inputWrapper: ['border-blue-500'],
      },
    },
    radius: {
      '2xl': {
        inputWrapper: 'rounded-2xl',
      },
      full: {
        inputWrapper: 'rounded-full',
      },
    },
    size: {
      sm: {
        inputWrapper: 'h-10 text-sm pr-9',
      },
      md: {
        inputWrapper: 'h-12 text-md pr-10',
      },
      lg: {
        inputWrapper: 'h-14 text-lg pr-11',
      },
    },
  },
  defaultVariants: {
    color: 'default',
    size: 'md',
  },
  compoundVariants: [
    // color & isFocused
    {
      color: 'default',
      isFocused: false,
      class: {
        inputWrapper: 'border-default-input-unfocus group-data-[hover=true]:border-default-input-focus',
        dropdownIcon: 'text-default-text-placeholder',
      },
    },
    {
      color: 'default',
      isFocused: true,
      class: {
        inputWrapper: 'border-default-input-focus bg-default-bg-white',
        dropdownIcon: 'text-default-text-contrast-low',
      },
    },
    {
      color: 'danger',
      isFocused: false,
      class: {
        inputWrapper: 'border-danger-input-unfocus group-data-[hover=true]:border-danger-input-focus',
        dropdownIcon: 'text-danger-text-placeholder',
      },
    },
    {
      color: 'danger',
      isFocused: true,
      class: {
        inputWrapper: 'border-danger-input-focus bg-default-bg-white',
        dropdownIcon: 'text-danger-text-contrast-low',
      },
    },
    {
      color: 'success',
      isFocused: false,
      class: {
        inputWrapper: 'border-success-input-unfocus group-data-[hover=true]:border-success-input-focus',
        dropdownIcon: 'text-success-text-placeholder',
      },
    },
    {
      color: 'success',
      isFocused: true,
      class: {
        inputWrapper: 'border-success-input-focus bg-default-bg-white',
        dropdownIcon: 'text-success-text-contrast-low',
      },
    },
    {
      color: 'primary',
      isFocused: false,
      class: {
        inputWrapper: 'border-primary-input-unfocus group-data-[hover=true]:border-primary-input-focus',
        dropdownIcon: 'text-primary-text-placeholder',
      },
    },
    {
      color: 'primary',
      isFocused: true,
      class: {
        inputWrapper: 'border-primary-input-focus bg-default-bg-white',
        dropdownIcon: 'text-primary-text-contrast-low',
      },
    },
    {
      color: 'secondary',
      isFocused: false,
      class: {
        inputWrapper: 'border-secondary-input-unfocus group-data-[hover=true]:border-secondary-input-focus',
        dropdownIcon: 'text-secondary-text-placeholder',
      },
    },
    {
      color: 'secondary',
      isFocused: true,
      class: {
        inputWrapper: 'border-secondary-input-focus bg-default-bg-white',
        dropdownIcon: 'text-secondary-text-contrast-low',
      },
    },
  ],
})

export type TSelectInputVariantProps = VariantProps<typeof selectInputVariants>
